import React, { useState, useEffect, useRef } from 'react'
import loader from '../../../../assets/img/loader.svg'
import Api from '../../../../_helpers/Api'
import AddOrEditGroup from './AddOrEditGroup'
import { useAuthDataContext } from '../../../../_providers/Auth'
import NoDataFound from '../../../partials/NoDataFound'
import Options from './GroupsOptions'
import { trans } from '../../../../_providers/Translation'
import { useHistory, useLocation } from 'react-router'
import Skeleton from 'react-loading-skeleton'

let timeout

function Groups(props) {

    const auth = useAuthDataContext()

    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const partnerId = props.id

    const modalAddOrEditRef = useRef(null)
    const searchTimeoutRef = useRef(null)

    const [state, setState] = useState({
        loading: true,
        data: [],
        update: false,
        filters: {
            name: '',
        },
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                name: searchParams.get('name') || '',
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    useEffect(() => {
        if (state.setFilter) {
            searchParams.set('page', state.page)

            Object.entries(state.filters).map(filter => {
                searchParams.set(filter[0], filter[1])
            })

            history.push('?' + searchParams.toString())
        }
    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])

    const loadData = () => {

        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'partners/groups/all?partner_id=' + partnerId + '&name=' + state.filters.name

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data,
                }))
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })

    }

    const handleAdd = () => {
        modalAddOrEditRef.current.add()
    }

    const handleCreate = van => {
        setState(prev => ({
            ...prev,
            update: Math.random().toString()
        }))

    }

    // update
    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id)
    }

    const handleUpdate = group => {
        setState(prev => ({
            ...prev,
            update: Math.random().toString()
        }))
    }

    // delete
    const handleDelete = id => {
        Api.post('partners/groups/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                setState(prev => ({
                    ...prev,
                    update: Math.random().toString()
                }))
            }
        })
    }

    function handleSearch(e) {
        const { name, value } = e.target

        clearTimeout(searchTimeoutRef.current)

        setState(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [name]: value
            },
        }))

        searchTimeoutRef.current = setTimeout(() => {
            setState(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }


    return (

        <div className="pannel">
            <AddOrEditGroup
                ref={modalAddOrEditRef}
                partnerId={partnerId}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <div className="top-part">
                <div className='left'>
                    <div className='filter-standard'>
                        <div className="col" data-id="4">
                            <input
                                id="search"
                                type="search"
                                name="name"
                                value={state.filters.name}
                                onChange={handleSearch}
                                placeholder={trans('labels.search')}
                            />
                        </div>
                    </div>
                </div>

                {(auth.isAdmin() || auth.isManager()) &&
                    <div className='right'>
                        <button className="button button-add button-small" onClick={handleAdd}>
                            {trans('buttons.add')}
                        </button>
                    </div>
                }
            </div>


            <hr />
            {state.loading
                ?
                <Skeleton height={35} count={10} />
                :
                state.data.length === 0
                    ?
                    <NoDataFound />
                    :
                    <>

                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{trans('labels.name')}</th>
                                        <th>{trans('labels.technicians')}</th>
                                        <th className="options">{trans('labels.options')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {state.data.map(e =>
                                        <tr key={'e' + e.id}>
                                            <td>{e.name}</td>
                                            <td>{e.selectedemployees_count}</td>
                                            <td className="options">
                                                <Options
                                                    id={e.id}
                                                    handleEdit={handleEdit}
                                                    handleDelete={handleDelete}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </>
            }
        </div>

    )
}

export default Groups